import trMessages from "./messages/tr_TR.json";
import azMessages from "./messages/az.json";

const messages = {
  az: azMessages,
  tr: trMessages,
  "tr-tr": trMessages,
  "az-Latn": azMessages,
  "az-Latn-AZ": azMessages,
  "az-AZ": azMessages,
};

export default messages;
